<div class="snack-bar-container">
  @if (data?.icon) {
    <div [ngClass]="iconColor" class="icon">
      <mat-icon>{{ data?.icon }}</mat-icon>
    </div>
  }
  <div class="data">
    @if (data?.title) {
      <div class="title">{{ data?.title | translation }}</div>
    }
    <div class="text">{{ data?.message | translation }}</div>
  </div>
</div>
